<template>
    <div v-if="!loading">
        <v-toolbar collapse style="position: fixed; top: 0">
            <v-btn icon @click="saveDialog = true">
                <v-icon>mdi-content-save</v-icon>
            </v-btn>
        </v-toolbar>

        <v-dialog v-model="saveDialog" max-width="600px">
            <v-card>
                <v-card-title>Сохранить страницу</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                                <v-text-field label="Адрес страницы" v-model="url"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-checkbox label="Опубликовать" v-model="isPublic"></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <div class="flex-md-grow-1"></div>
                    <v-btn
                            color="#8a2be2"
                            text
                            @click="saveDialog = false"
                    >
                        Закрыть
                    </v-btn>
                    <v-btn
                            color="#8a2be2"
                            text
                            @click="savePage"
                    >
                        Сохранить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-row justify="center" >
            <v-col :cols="inputCols">
                <html-editor class="view-title" v-model="title"></html-editor>
            </v-col>
        </v-row>
        <PageBuilder v-if="!loading" :protoblocks="blocks" style="margin: 0 auto;" @update-blocks="blocks = $event"></PageBuilder>

        <v-snackbar
                v-model="snackbar.value"
        >
            {{ snackbar.text }}
            <v-btn
                    color="pink"
                    text
                    @click="snackbar.value = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import PageBuilder from "../../components/controlpanel/PageBuilder/ThePageBuilder";
    import HtmlEditor from "../../components/controlpanel/PageBuilder/HtmlEditor";
    import {HTTP} from "../../axios";

    export default {
        name: "PageAdd",
        components:{
            PageBuilder,
            HtmlEditor
        },
        data(){
            return{
                loading: false,
                title: "Заголовок страницы",
                url: "",
                isPublic: false,
                blocks: [],
                saveDialog: false,
                snackbar: {
                    text: "",
                    value: false
                }
            }
        },
        computed: {
            inputCols () {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return 12
                    case 'sm': return 12
                    case 'md': return 12
                    case 'lg': return 6
                    case 'xl': return 6
                }
                return false
            }
        },
        methods:{
            savePage(){
                var data = {}
                if(this.isPublic){
                    data.isPublic = true
                }
                data.blocks = JSON.stringify(this.blocks)
                data.title = this.title
                if(this.url != ""){
                    data.url = this.url
                } else {
                    this.showSnackbar("Адрес не введен")
                }
                if(this.$route.meta.mode == 'edit'){
                    HTTP
                        .put("pages/" + this.$route.params.id, JSON.stringify(data),{
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                        .then(() => {
                            this.showSnackbar("все сохранилось!")
                            this.$router.push("/admin/pages")
                        })
                        .catch(e => {
                            if(e.response.status === 409){
                                this.showSnackbar(e.response.data.error)
                            } else {
                                this.showSnackbar("Что-то пошло не так")
                            }
                        })
                } else {
                    HTTP
                        .post("pages", JSON.stringify(data),{
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                        .then(() => {
                            this.showSnackbar("все сохранилось!")
                            this.$router.push("/admin/pages")
                        })
                        .catch(e => {
                            if(e.response.status === 409){
                                this.showSnackbar(e.response.data.error)
                            } else {
                                this.showSnackbar("Что-то пошло не так")
                            }
                        })
                }

            },
            getPage(mode){
                this.loading = true
                HTTP
                    .get(`pages/${this.$route.params.id}`)
                    .then(r => {
                        if(mode ==='edit')
                        {
                            this.isPublic = r.data.page.is_public == 1 ? true : false
                        }
                        if(mode ==='copy')
                        {
                            this.isPublic = false
                        }

                        this.blocks = JSON.parse(r.data.page.data)
                        this.title = r.data.page.title
                        mode==='copy'? this.url = r.data.page.url+'(copy)': this.url = r.data.page.url

                        this.loading = false
                    })
                    .catch(e => {
                        if(e.response.status == 404){
                            this.showSnackbar("Такой страницы не существует")
                        }
                    })
            },

            showSnackbar(text){
                this.snackbar.text = text;
                this.snackbar.value = true;
            }
        },
        beforeMount() {
            if(this.$route.meta.mode == "edit" ){
                this.getPage('edit')
            }
            if( this.$route.meta.mode == "copy")
            {
                this.getPage('copy')

            }

        }
    }
</script>

<style scoped>
    .view-title{
        font-size: 40px;
        color: #18224b;
        line-height: 1.23;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 600;
        padding: 20px 0 60px 0;
        text-align: center;
    }
</style>